// 3칸 진행바 — 신청 → 검차완료 → 매입 결정. props: { status }
// 상태 매핑은 앱 simple_progress_bar.dart statesOf 그대로:
//   open/taken/inspecting → [done, current, todo] · completed → [done, done, current]
//   decided/rejected      → [done, done, done] (3칸 라벨을 결과로 치환) · cancelled → [done, todo, todo] + 취소 뱃지
import React from 'react';
import { T, R } from '../../theme';
import { useT } from '../../../i18n/I18nProvider';

export function statesOf(status) {
  if (status === 'completed') return ['done', 'done', 'current'];
  if (status === 'decided' || status === 'rejected') return ['done', 'done', 'done'];
  if (status === 'cancelled') return ['done', 'todo', 'todo'];
  return ['done', 'current', 'todo'];
}

var rowStyle = { display: 'flex', alignItems: 'center', gap: 0 };
var lineBase = { flex: 1, height: 2, margin: '0 6px' };
var labelRow = { display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', fontSize: 10.5, marginTop: 6, fontWeight: 600, color: T.faint };
var capStyle = { marginTop: 10, fontSize: 11.5, fontWeight: 700, color: T.warn, textAlign: 'center' };
var badgeStyle = { margin: '10px auto 0', display: 'table', padding: '2px 10px', borderRadius: R.pill,
  background: T.track, color: T.faint, fontSize: 10.5, fontWeight: 800, border: '1px solid ' + T.bd };

function dotStyle(state) {
  var s = { width: 26, height: 26, borderRadius: '50%', display: 'grid', placeItems: 'center', flex: 'none',
    fontSize: 11, fontWeight: 800, direction: 'ltr', boxSizing: 'border-box' };
  if (state === 'done') return Object.assign(s, { background: T.accentTint, border: '1.5px solid ' + T.navy, color: T.navy });
  if (state === 'current') return Object.assign(s, { background: T.warnTint, border: '1.5px solid ' + T.warnBd, color: T.warn });
  return Object.assign(s, { background: T.card, border: '1.5px solid ' + T.bd, color: T.faint });
}

function SimpleProgressBar(props) {
  var t = useT();
  var status = props.status;
  var states = statesOf(status);
  var last = status === 'decided' ? t('evalStatusDecided')
    : status === 'rejected' ? t('evalStatusRejected')
      : t('simpleProgYourDecision');
  var labels = [t('simpleProgRequested'), t('simpleProgInspected'), last];
  return (<div className="ss-prog">
    <div style={rowStyle}>
      <span style={dotStyle(states[0])}>1</span>
      <i style={Object.assign({}, lineBase, { background: states[1] === 'todo' ? T.bd : T.navy })} />
      <span style={dotStyle(states[1])}>2</span>
      <i style={Object.assign({}, lineBase, { background: states[2] === 'todo' ? T.bd : T.navy })} />
      <span style={dotStyle(states[2])}>3</span>
    </div>
    <div style={labelRow}>
      {labels.map(function (l, i) {
        var on = states[i] !== 'todo';
        return (<span key={i} style={{ textAlign: i === 0 ? 'start' : i === 2 ? 'end' : 'center',
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
          color: states[i] === 'current' ? T.warn : on ? T.ink : T.faint, fontWeight: on ? 800 : 600 }}>{l}</span>);
      })}
    </div>
    {status === 'open' || status === 'taken' || status === 'inspecting'
      ? <div style={capStyle}>{t('simpleProgWaiting')}</div> : null}
    {status === 'cancelled' ? <div style={badgeStyle}>{t('evalStatusCancelled')}</div> : null}
  </div>);
}

export default SimpleProgressBar;
